/* eslint-disable @typescript-eslint/no-redeclare */
export type ContactStatus = (typeof ContactStatus)[keyof typeof ContactStatus];
export const ContactStatus = {
  AVAILABLE: 'AVAILABLE',
  BOUNCES_EMAILS: 'BOUNCES_EMAILS',
  MARKED_AS_SPAM: 'MARKED_AS_SPAM',
  NOT_FOUND: 'NOT_FOUND',
  OTHER: 'OTHER',
} as const;
